import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import Layout from "../layouts/Layout";
import KidsImage from "../assets/girl.webp";
import ContactIllustration from "../assets/contact_us_hero.png";
import { LocationIcon, MessagingIcon, WhatsAppIcon } from "../components/Icons";
import CardImg from "../assets/contact_us_card.png";
import Button from "../components/common/Button";

const CONTACT_DETAILS = [
  {
    icon: LocationIcon,
    text: "1st Floor IT Park near Missile Chowk, Mandian, Abbottabad, Pakistan",
  },
  {
    icon: WhatsAppIcon,
    text: "+92 319 0412670",
  },
  {
    icon: MessagingIcon,
    text: "info@steamminds.org",
  },
];

const ContactUs = () => {
  const formRef = useRef();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const handleChange = ({ target: { name, value } }) => {
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setSuccessMessage("");
    setErrorMessage("");
  };

  const validateForm = () => {
    const newErrors = {};

    if (!form.name.trim()) {
      newErrors.name = "Name is required.";
    }

    if (!form.email.trim()) {
      newErrors.email = "Email is required.";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(form.email)) {
        newErrors.email = "Please enter a valid email address.";
      }
    }

    if (!form.subject.trim()) {
      newErrors.subject = "Subject is required.";
    }

    if (!form.message.trim()) {
      newErrors.message = "Message is required.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setSuccessMessage("");
    setErrorMessage("");

    if (!validateForm()) return;

    setLoading(true);

    try {
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          from_name: form.name,
          to_name: "Jawad Ali",
          from_email: form.email,
          to_email: "alishahsyedjawad3445@gmail.com",
          subject: form.subject,
          message: form.message,
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
      );

      setSuccessMessage("Your message has been sent successfully.");

      setForm({
        name: "",
        email: "",
        subject: "",
        message: "",
      });

      setErrors({});
    } catch (error) {
      console.error("EmailJS Error:", error);

      setErrorMessage(
        "Something went wrong while sending your message. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="bg-[#F5F5F566]">
        <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-10 px-4 py-10 sm:px-6 sm:py-14 md:px-10 md:py-20 lg:flex-row lg:items-center lg:justify-between lg:gap-8 lg:px-14 lg:py-[110px]">
          <div className="w-full">
            <h1 className="text-[28px] font-bold leading-tight text-black sm:text-4xl sm:leading-10 lg:text-5xl lg:leading-[56px]">
              Let&apos;s Build Something{" "}
              <span className="text-[#FF6636]">Great Together</span>
            </h1>

            <p className="mt-4 max-w-[829px] text-base leading-6 text-black sm:mt-[22px] sm:text-lg sm:leading-7 lg:text-xl lg:leading-[23px]">
              We&apos;re here to answer your questions, discuss your ideas, and
              help you get started. Reach out today and your — journey begins
              with a message.
            </p>

            <h2 className="mt-6 text-[24px] font-bold leading-tight text-black sm:mt-8 sm:text-[32px] sm:leading-[38px]">
              Get in Touch
            </h2>
            <p className="mt-2.5 text-sm leading-5 text-black sm:text-base">
              We&apos;d love to hear from you, whether you have questions,
              ideas, or just want to say hello.
            </p>

            <ul className="mt-6 space-y-4 sm:mt-[34px]">
              {CONTACT_DETAILS.map(({ icon: Icon, text }) => (
                <li
                  key={text}
                  className="flex items-start gap-4 text-sm font-medium leading-5 text-black sm:items-center sm:gap-6 sm:text-base"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center bg-[#FF6636] text-white sm:h-12 sm:w-12">
                    <Icon />
                  </span>
                  <span className="min-w-0 break-words">{text}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="hidden w-full max-w-[484px] lg:block">
            <img
              src={KidsImage}
              alt="Happy student with laptop"
              className="h-auto w-full object-contain lg:h-[520px] xl:h-[670px]"
            />
          </div>
        </div>
      </div>

      <div className="bg-[linear-gradient(to_bottom,_#923D8C33_50%,_white_50%)] px-4 py-12 sm:px-6 lg:px-8 lg:py-16 2xl:pb-24 2xl:pt-20">
        <div className="mx-auto w-full max-w-[1728px] rounded-[14px] bg-white shadow-[0_0_9.8px_1px_#00000040] sm:rounded-[18px]">
          <div className="mx-auto flex max-w-[1340px] flex-col items-center justify-center gap-8 px-4 pb-10 pt-10 sm:px-6 sm:pt-12 md:flex-row md:items-start md:gap-14 lg:gap-24 lg:px-8 2xl:gap-[157px] 2xl:px-0 2xl:pb-14 2xl:pt-24">
            <div className="w-full max-w-[330px] sm:max-w-[380px] lg:max-w-[454px]">
              <img
                src={CardImg}
                alt="Contact support illustration"
                className="w-full h-auto object-contain"
              />
            </div>

            <div className="w-full flex-1">
              <h2 className="text-[28px] font-bold leading-tight text-black sm:text-[32px] sm:leading-[38px] lg:text-[40px] lg:leading-[47px]">
                Contact Us
              </h2>

              <form
                ref={formRef}
                onSubmit={handleSubmit}
                className="mt-6 space-y-5 sm:space-y-6 xl:mt-8 xl:space-y-[30px]"
              >
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                  placeholder="Enter your Name"
                  className="h-12 w-full bg-[#F5F5F5] px-3 text-sm text-black placeholder:text-gray-400 outline-none ring-0 sm:h-[53px] sm:px-2.5"
                />
                {errors.name && (
                  <p className="mt-1 text-sm text-red-500">{errors.name}</p>
                )}

                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                  placeholder="Enter your Email"
                  className="h-12 w-full bg-[#F5F5F5] px-3 text-sm text-black placeholder:text-gray-400 outline-none ring-0 sm:h-[53px] sm:px-2.5"
                />
                {errors.email && (
                  <p className="mt-1 text-sm text-red-500">{errors.email}</p>
                )}
                <input
                  type="text"
                  name="subject"
                  value={form.subject}
                  onChange={handleChange}
                  required
                  placeholder="Enter Message Subject"
                  className="h-12 w-full bg-[#F5F5F5] px-3 text-sm text-black placeholder:text-gray-400 outline-none ring-0 sm:h-[53px] sm:px-2.5"
                />

                {errors.subject && (
                  <p className="mt-1 text-sm text-red-500">{errors.subject}</p>
                )}

                <textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  required
                  rows={4}
                  placeholder="Go a head, we're listening"
                  className="h-28 w-full resize-none bg-[#F5F5F5] p-3 text-sm text-black placeholder:text-gray-400 outline-none ring-0 sm:h-[100px] sm:p-2.5"
                />
                {errors.message && (
                  <p className="mt-1 text-sm text-red-500">{errors.message}</p>
                )}
                {successMessage && (
                  <div className="mb-4 rounded bg-green-100 p-3 text-sm text-green-700">
                    {successMessage}
                  </div>
                )}

                {errorMessage && (
                  <div className="mb-4 rounded bg-red-100 p-3 text-sm text-red-700">
                    {errorMessage}
                  </div>
                )}

                <Button
                  btnText={loading ? "Sending..." : "Submit"}
                  type="submit"
                  disabled={loading}
                  btnClassName="mt-6 w-full rounded-full bg-[#923D8C] px-10 py-2.5 text-lg font-bold text-white disabled:opacity-50 sm:mt-8 sm:w-auto sm:px-16 sm:py-[7px] sm:text-xl xl:mt-11 xl:px-20 xl:text-2xl"
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ContactUs;
